import React from "react";
import { Box, Typography, Link } from "@mui/material";

// const Footer = () => {
//   return (
//     <footer className="blue-grey darken-4">
//       <div className="center">
//         <p className="white-text">&copy; 2022 Yep Education</p>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        backgroundColor: "#263238",
        color: "white",
      }}
    >
      <Typography variant="body2" color="inherit" align="center">
        {"© "}
        {new Date().getFullYear()}{" "}
        <Link color="inherit" href="https://yep.education/" underline="hover">
          Yep Education
        </Link>
        . All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default React.memo(Footer);
